import { render, staticRenderFns } from "./AddActionsBtn.vue?vue&type=template&id=4de453e4&"
import script from "./AddActionsBtn.vue?vue&type=script&lang=js&"
export * from "./AddActionsBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports